module.exports = __webpack_public_path__ + "static/media/deploy.1a40d905.png";